import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IToolbarActionDefinition } from "../../../../../utils/emails";
import Menu from "../../../components/Menu";
import { MenuItemAdapter } from "../MenuItemAdapter";
import { LexicalEditor } from "lexical";

type CustomActionProperties =
{
    editor: LexicalEditor
    action: IToolbarActionDefinition
    onClick: (item: MenuItemAdapter) => void
}

export default function CustomAction({ action, editor, onClick }: CustomActionProperties)
{
    const tooltip = action.hint || action.text || '';

    switch (action.type)
    {
        case 'divider':
            return <div className="divider" />;
        case 'button':
            return <button
                type="button"
                className="btn"
                onMouseDown={event => event.preventDefault()}
                onClick={() => { action.onSelected?.(editor); }}
                title={tooltip}
                aria-label={tooltip}
            >
                {action.icon && <FontAwesomeIcon icon={action.icon} />} {action.text}
            </button>;
        default:
            return <Menu item={new MenuItemAdapter(action)} root={true} onClick={onClick} />;
    }
}